/**************************************************
 * Nombre:       Formulario_Varietal
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AgricultureOutlined,
    CategoryOutlined,
    EmojiFoodBeverageOutlined,
    Flag,
    FlagOutlined,
    Google
} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSPRODUCTO} from "../../../Constantes";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";

const Formulario_Varietal = ({...props}) => {
    const [categorias, setCategorias] = useState([]);
    const [regiones, setRegiones] = useState([]);
    const [origenes, setOrigenes] = useState([]);

    useEffect(() => {
        obtenerCol('categorias').then(dox => {
            setCategorias(dox.data)
        })
        obtenerCol('regiones').then(dox => {
            setRegiones(dox.data)
        })
        obtenerCol('origenes').then(dox => {
            setOrigenes(dox.data)
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={CategoryOutlined} nombre={'Categoria'} dato={'categoria'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={categorias.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={AgricultureOutlined} nombre={'Region'} dato={'region'} {...props}
                                   requerido={'La region es requerido'}
                                   opciones={regiones.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Origen'} dato={'origen'} {...props}
                                   requerido={'El origen es requerido'}
                                   opciones={origenes.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={EmojiFoodBeverageOutlined} nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Varietal